import { render, staticRenderFns } from "./PublishTopic.vue?vue&type=template&id=83dbbd50&"
import script from "./PublishTopic.vue?vue&type=script&lang=ts&"
export * from "./PublishTopic.vue?vue&type=script&lang=ts&"
import style0 from "./PublishTopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports